module.exports = __webpack_public_path__ + "img/shangmenzuofan_image_zhucan.29bf9b83.png";